import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class IntermediaryService {

  env = environment;

  constructor(private readonly http: HttpClient) { }
  
  getIntermediaryDetails(data: any)
 {
  return this.http.post(this.env.webApiUrl + 'api/Intermediary/GetIntermediaryDetails', data);
 }
}

